<template>
    <div>
        <h1>Settings</h1>
        <p>Get Started page</p>
    </div>
</template>